import React, { ReactElement } from 'react';
import { TextInputField } from '@bucketplace/commerce-admin-ui';

import {
  FormContent,
  InspectorFormProvider,
  LogDataFormGroup,
} from '../../../components';
import { useStickyTabContext } from '../../../contexts';
import { DocumentInspectorProps, DocumentNode } from '../../../types';
import { StickyTabItemProps } from './StickyTabItem';

export function StickyTabItemInspector({
  value,
  onChange,
}: DocumentInspectorProps<StickyTabItemProps>): ReactElement {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent
        header="탭 아이템 id"
        required
      >
        <TextInputField
          name="id"
          placeholder="앵커링 타켓으로 지정할 id를 입력해주세요."
          width="100%"
          rules={{
            required: true,
            validate: (value) => value.trim() !== '',
          }}
        />
      </FormContent>
      <LogDataInput
        value={value}
      />
    </InspectorFormProvider>
  );
}

function LogDataInput({ value }: { value: DocumentNode<StickyTabItemProps> }): ReactElement {
  const { setLogData } = useStickyTabContext();
  const { children, ...others } = value ?? {};

  return (
    <LogDataFormGroup
      nodeKey={value?.key}
      {...setLogData?.(others)}
    />
  );
}

